import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import { DescriptionList, Flex, Text } from '@applyboard/crystal-ui';
import { useLegacyApplicationRequirements } from "../../data";
import { HybridRequirementDialogButton } from "../HybridRequirementDialogButton";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function HybridRequirementDecisionReasons(_ref) {
  var requirementId = _ref.requirementId;
  var _useLegacyApplication = useLegacyApplicationRequirements(),
    applicationRequirements = _useLegacyApplication.applicationRequirements;
  var requirement = applicationRequirements.find(function (requirement) {
    return requirement.id === requirementId;
  });
  if (!(requirement !== null && requirement !== void 0 && requirement.decisionReasons.length)) {
    return null;
  }
  if (requirement.decisionReasons.length === 1) {
    return _jsx(DecisionReason, {
      reason: requirement.decisionReasons[0],
      requirementId: requirementId
    });
  }
  return _jsx(Flex, {
    children: _jsx(DescriptionList, {
      variant: "grid",
      children: requirement.decisionReasons.map(function (reason, index) {
        return _jsx(DescriptionList.Item, {
          term: "Attempt ".concat(index + 1),
          details: _jsx(DecisionReason, {
            reason: reason,
            requirementId: requirementId
          }),
          justify: "space-between",
          align: "center"
        }, index);
      })
    })
  });
}
function DecisionReason(_ref2) {
  var reason = _ref2.reason,
    requirementId = _ref2.requirementId;
  return _jsxs(Flex, {
    gap: 4,
    align: "center",
    children: [_jsx(Text, {
      children: "".concat(reason.title).concat(reason.notes ? " - ".concat(reason.notes) : '')
    }), reason.formData && _jsx(HybridRequirementDialogButton, {
      requirementId: requirementId,
      pastResponse: reason.formData
    })]
  });
}